import { Fragment } from 'react';

import FormSpacer from 'bloko/blocks/form/FormSpacer';
import NumericInput from 'bloko/blocks/numericInput';

import useTrls from 'hooks/translation/useTrls';

import InputWithMultiDatePicker from 'components/InputWithMultiDatePicker';

import AccountStatisticsTable from 'components/Admin/Reports/AccountStatisticsReport/AccountStatisticsTable';
import fetchAccountStatistics from 'components/Admin/Reports/AccountStatisticsReport/fetchAccountStatistics';
import ReportWrapper from 'components/Admin/Reports/ReportWrapper';

import { setAccountStatisticsAccountId, setAccountStatisticsDates } from 'store/models/accountStatistics';
import { useDispatch, useSelector } from 'store/utils';

const AccountStatisticsReport = () => {
    const { from, to, accountId, isLoad } = useSelector((state) => state.accountStatistics);
    const dispatch = useDispatch();
    const trl = useTrls();

    return (
        <ReportWrapper
            title={trl('admin.SectionTabs.accountStatistics')}
            filter={
                <Fragment>
                    <InputWithMultiDatePicker
                        action={(from, to) => {
                            dispatch(setAccountStatisticsDates({ from, to }));
                        }}
                        from={from}
                        to={to}
                    />
                    <FormSpacer>
                        <NumericInput
                            value={accountId}
                            onChange={(value) => dispatch(setAccountStatisticsAccountId(value))}
                            errors={{
                                notNumber: trl('input.number.error'),
                            }}
                            placeholder={trl('admin.accountStatisticsReport.accountId.placeholder')}
                        />
                    </FormSpacer>
                </Fragment>
            }
            content={<AccountStatisticsTable />}
            isLoadContent={isLoad}
            onClickSearch={() => dispatch(fetchAccountStatistics())}
        />
    );
};

export default AccountStatisticsReport;
